export default "__VITE_ASSET__cb977cf2__"